import { Box, Drawer,List } from "@mui/material";
import React, { useState } from "react";
import { OpenInNewWindow, closePopup } from "../../style/images";
import { ProductCode, ProductDescription } from "./productItem";
import { useSelector } from "react-redux";
import { translate } from "../services";
import { CustomContent } from "./CustomContent";
import { getProductLink } from "../util";

export const DetailedModal= ({item, view, showItemDetails, toogleItemDetail,showMobileLinkContainer,accessorylength})=>{
    // const [item, setItem] = useState("");
    // const [view, setView] = useState("");
    const viewSettings = useSelector(state=>state.viewSettings)
    const renderContent = ( layout, item, key )=> {
        return <CustomContent fromDetailedView key={ key } layout={ layout } data={ item } view={view} accessorylength={accessorylength} />;
    }
  
    const renderColumn = ( layout, item, key, count )=> {
  
      let content = layout.rows
        ? layout.rows.map( ( row, key ) => renderRow( row, item, key, count ) )
        : renderContent( layout, item, key );
      
      const className = `col-${key}`;
      return <div className={className} key={key}>{ content }</div>
    }
  
    const renderRow = (layout, item, key, count)=>{
      const content = layout.columns
        ? layout.columns.map( ( col, key) => renderColumn( col, item, key, count+1 ) )
        : renderContent( layout, item, key );
      
        const className = `count-${count}`
      return <div key={key} className={className}>{ content }</div>
    }
    const renderHeader = () => {
        if (showMobileLinkContainer) {
            return <span className='header'>{translate("Actions")}</span>
        } else {
            return <>
                <span className='header'>{translate("Item Details")}</span>
                <div className='product-details'>
                    <ProductCode {...item} accessorylength={accessorylength} />
                    <ProductDescription product={item} ></ProductDescription>
                </div></>
        }
    }
    const renderMiddleContent = () => {
        if (showMobileLinkContainer) {
            return <div class="link-item-details">
                <List className='link-item'>
                    {item}
                </List>
            </div>
        } else {
            return <>
                {viewSettings["product"]["desktop"]["detailed"].rows[0].columns
                    .filter(column => column.rows)
                    .map(column => column.rows)
                    .map((row) => {
                        return <>
                            <Box sx={{ height: "1px", width: "100%", background: "var(--primary-color-grey-10, #EBEBEB)" }}></Box>
                            <div className='extra-details'>{row.map((row, key) => renderRow(row, item, key, 0))}</div>
                        </>
                    })}
                <div className='link-container'>
                    <a href={getProductLink(item.name)} target="_blank">
                        <div className='link-box'>
                            <Box sx={{ width: "16px", height: "16px" }} component="img" src={OpenInNewWindow}></Box>
                            <span>{translate("Go to product page")}</span>
                        </div>
                    </a>
                </div></>
        }
    }
    return <Drawer anchor='bottom' open={showItemDetails} onClose={()=>{toogleItemDetail()}}
    PaperProps={{
        sx: {
        boxShadow:"none",
        borderRadius: "12px 12px 0px 0px",
        background: "var(--brand-primary-white, #FFF)"
        }
    }}>
        <div className='mobile-item-details'>
        <div className='close-icon'>
            <Box component="img" src={closePopup} sx={{width:"18px", height:"18px"}} onClick={()=>{toogleItemDetail()}}></Box>
        </div>
        <div className='header-frame'>
            {  renderHeader()}
        </div>
            { renderMiddleContent()}
        </div>
    </Drawer>
}